import { render, staticRenderFns } from "./importfolderdialog.vue?vue&type=template&id=5de50794&scoped=true&"
import script from "./importfolderdialog.vue?vue&type=script&lang=js&"
export * from "./importfolderdialog.vue?vue&type=script&lang=js&"
import style0 from "./importfolderdialog.vue?vue&type=style&index=0&id=5de50794&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de50794",
  null
  
)

export default component.exports